import { autoMount } from '../../../utils/autoMount';
import { TvSection } from '../../../components/organisms/tvSection';

autoMount({ TvSection });
